<template>
  <div class="whatsAPP pointer" @click="whatsAPPClick">
    <img src="@/assets/img/Group 1877.png">
  </div>
</template>

<script>
export default {
  methods: {
    whatsAPPClick() {
      window.open('http://www.hkj.buzz/EqbEBJwN')
    }
  }
}
</script>

<style  lang="scss" scoped>
.whatsAPP {
  position: fixed;
  right: -4px;
  bottom: 15px;
  z-index: 101;
  img {
    width:84px;
    height:84px;
  }
}
</style>
